export default {
    data: function () {
        return {
            //
        }
    },
    methods: {
        copyElement: function () {
            EaseEventBus.fire('copyElement', {
                id: this.index
            });
        }
    }
};
